// extracted by mini-css-extract-plugin
export var center = "_1p-2";
export var clickableRow = "_1p-5";
export var expandedRow = "_1p-7";
export var hoverable = "_1p-4";
export var left = "_1p-1";
export var right = "_1p-3";
export var row = "_1p-0";
export var selectedRow = "_1p-6";
export var summaryRow = "_1p-8";